<template>
  <div class="seal-wrapper">
    <img class="blind_seal" :src="icon">
  </div>
</template>

<script>
export default {
  name: "EmptyInfo",
  props: {
    icon: {
      type: String,
      default: function() {
        return '/img/emptyDep.png'
      }
    }
  }
}
</script>

<style lang="scss">
.seal-wrapper {
  padding: 36px 0 50px;

  img {
    top: 0;
  }
}
</style>
